module.exports = __webpack_public_path__ + "static/website_creation-7da2141c24576e0ee50f03c78961d988.jpg";